import React from "react";

const Footer = () => {
  return (
    <div className="footer-main">
      <div className="bg-footer">
        <div className="footer">
          <div className="footer-left">
            <div className="footer-logo-text-container">
              <img
                className="footer-logo"
                src="/Assets/logo.webp"
                alt="Logo"
                loading="lazy"
              ></img>
              <label className="footer-heading">SURYA VILAS PALACE</label>
            </div>
            <p className="footer-text">
              Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit
              sed semper vitae faucibus consequat. Sed dui auctor aliquam quam
              urna magna feugiat egestas placerat. Pharetra arcu nulla lacus
              molestie quis dignissim quis tempor interdum. Quam blandit iaculis
            </p>
            <div className="footer-input-container">
              <input
                className="footer-input"
                placeholder="Enter Your Phone no"
              ></input>
              <div className="footer-line"></div>
              <button className="footer-button">Get In Touch</button>
            </div>
          </div>

          <div className="footer-middle">
            <label className="footer-heading">QUICK LINKS</label>
            <div className="footer-middle-main">
              <p className="footer-middle-text">Home</p>
              <p className="footer-middle-text">About Us</p>
              <p className="footer-middle-text">Room Types</p>
              <p className="footer-middle-text">Gallery</p>
              <p className="footer-middle-text">Privacy Policy</p>
              <p className="footer-middle-text">Contact Us</p>
            </div>
          </div>
          <div className="footer-right">
            <label className="footer-heading">CONTACT</label>
            <div className="footer-right-main">
              <div className="footer-right-container">
                <img
                  className="location"
                  src="/Assets/location.png"
                  alt="location"
                  loading="lazy"
                ></img>
                <span className="footer-right-text">59 sector bharatpur</span>
              </div>
              <div className="footer-right-container">
                <img
                  loading="lazy"
                  src="/Assets/callicon.webp"
                  alt="phone"
                ></img>
                <span className="footer-right-text">9876545360</span>
              </div>
              <div className="footer-right-container ">
                <img
                  src="/Assets/mailicon.webp"
                  alt="mail"
                  className="footer-mail"
                ></img>
                <span className="footer-right-text">
                  suryavilaspalace@gmail.com
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="castle">
          <img
            className="castle-img"
            alt="castle"
            src="/Assets/Castle.webp"
          ></img>
        </div>
      </div>
    </div>
  );
};

export default Footer;
